<div class="row">
    <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
    </div>
</div>
<div class="row" *ngIf="lista && lista.length === 0">
    <div class="col-12">
        <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
    </div>
</div>
<div class="row" *ngIf="lista && lista.length > 0">
    <div class="col-12 table-responsive">
        <table class="table table-eddy">
            <thead>
                <tr>
                    <th scope="col" style="width: 10%;">Data</th>
                    <th scope="col" style="width: 20%;">Acão</th>
                    <th scope="col" style="width: 10%;">Mês</th>
                    <th scope="col" style="width: 40%;">Justificativa</th>
                    <th scope="col" style="width: 30%;">Responsavel</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of lista">
                    <td>{{item.nome}} {{item.data_cadastro | date : 'dd/MM/yyyy' : 'GMT'}} </td>
                    <td>{{item.abertura ? 'Abertura' : 'Encerramento'}}</td>
                    <td>{{getMes(item.mes)}}</td>
                    <td>{{item.descricao}}</td>
                    <td>{{item.responsavel.nome}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="row float-right" *ngIf="lista && lista.length > 0">
    <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
            (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
    </div>
</div>
<br>